import React from "react";
import queryString from 'query-string';
import moment from "moment";

import Shimmer from "../../component/common/Shimmer";
// import HeterIskaViewer from '../../component/heter-iska/uwm/HeterIskaPDF';

import UWMHeterIskaViewer from '../../component/heter-iska/uwm/HeterIskaPDF';
import PennyMACHeterIskaViewer from '../../component/heter-iska/pennymac/HeterIskaPDF';
import ROCHeterIskaViewer from '../../component/heter-iska/roc-capital/HeterIskaPDF';
import PowerExpressHeterIskaViewer from '../../component/heter-iska/power-express/HeterIskaPDF';
import AAndDHeterIskaViewer from '../../component/heter-iska/a-and-d/HeterIskaPDF';
import NewrezWholesaleHeterIskaViewer from '../../component/heter-iska/newrez-wholesale/HeterIskaPDF';
import LoanStoreHeterIskaViewer from '../../component/heter-iska/loan-store/HeterIskaPDF';
import NFTYHeterIskaViewer from '../../component/heter-iska/nfty/HeterIskaPDF';

import SignatureCanvas from 'react-signature-canvas'
import ModalWindow from "../../component/common/ModalWindow";
import constant from "../../constant";
import WithToastContext from "../../context/ToastContext";

import { sleep } from "../../utils";
import { getPublicDetailByUID, uploadSignature } from "../../action/LoanHeterIskaAction";

class HeterIskaSignature extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        const parsed = queryString.parse(props.location.search);

        this.state = {
            uid: parsed.uid,
            documentDetail: undefined,
            linkDetail: undefined,
            showModal: false,
            showApproveConfirm: false,
            signatureDataURL: undefined
        }
    }

    componentDidMount() {
        const { uid } = this.state;
        getPublicDetailByUID(uid).then((res: any) => {
            if (res.error) {
                this.props.context.toast.error(res.error)
            } else {
                const { documentDetail, linkDetail } = res.result;
                if (linkDetail.linkForBorrower) {
                    documentDetail.borrowerSignatureDate = linkDetail.todaysDate;
                } else {
                    documentDetail.coBorrowerSignatureDate = linkDetail.todaysDate;
                }
                this.setState({ documentDetail, linkDetail });
            }
        })
    }

    onShowModal = () => {
        this.setState({ showModal: true });
    }

    onHideModal = () => {
        this.setState({ showModal: false });
    }

    render() {
        const { showModal, showApproveConfirm, documentDetail, linkDetail } = this.state;
        return <>
            {
                showModal && this.renderModal()
            }
            {
                showApproveConfirm && this.renderApproveConfirmModal()
            }
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-8" style={{ height: '100vh' }}>
                        {
                            documentDetail
                                ? this.renderHeterIska()
                                : <Shimmer />
                        }
                    </div>
                    <div className="col-md-4">
                        {
                            linkDetail
                                ? this.renderSideBar()
                                : <Shimmer />
                        }
                    </div>
                </div>
            </div>

        </>
    }

    renderHeterIska = () => {
        const { documentDetail } = this.state;
        const { lenderId } = documentDetail;
        return (
            <>
                {
                    lenderId === constant.lenderId.pennyMac && <PennyMACHeterIskaViewer detail={documentDetail} />
                }
                {
                    lenderId === constant.lenderId.roc && <ROCHeterIskaViewer detail={documentDetail} />
                }
                {
                    lenderId === constant.lenderId.uwm && <UWMHeterIskaViewer detail={documentDetail} />
                }
                {
                    lenderId === constant.lenderId.aAndD && <AAndDHeterIskaViewer detail={documentDetail} />
                }
                {
                    lenderId === constant.lenderId.powerExpress && <PowerExpressHeterIskaViewer detail={documentDetail} />
                }
                {
                    lenderId === constant.lenderId.newrezWholesale && <NewrezWholesaleHeterIskaViewer detail={documentDetail} />
                }
                {
                    lenderId === constant.lenderId.loanStore && <LoanStoreHeterIskaViewer detail={documentDetail} />
                }
                {
                    lenderId === constant.lenderId.nfty && <NFTYHeterIskaViewer detail={documentDetail} />
                }
            </>
        )
    }

    renderSideBar = () => {
        const { linkDetail, signatureDataURL } = this.state;
        const expiresOn = linkDetail ? moment(linkDetail.createdOn).add(3, 'days') : undefined;
        return (
            <>
                <h5 className="mt-3">Link Detail</h5>
                {
                    linkDetail ? <>
                        <div className="d-flex justify-content-between" >
                            <span>For</span>
                            <span>{linkDetail.linkForBorrower ? 'Borrower' : 'Co-Borrower'}</span>
                        </div>
                        <div className="d-flex justify-content-between" >
                            <span>Generated On</span>
                            <span>{moment(linkDetail.createdOn).format(constant.formatting.usDateTimeFormat)}</span>
                        </div>
                        <div className="d-flex justify-content-between" >
                            <span>Expires On</span>
                            <span>{expiresOn.format(constant.formatting.usDateTimeFormat)}</span>
                        </div>
                    </>
                        : <Shimmer />
                }

                <hr />
                <div>
                    <div className="text-danger">
                        Please dont share this URL with unknow people.
                    </div>
                    <div className="py-3" style={{ width: '100%' }}>
                        <button
                            onClick={this.onShowModal}
                            className="btn btn-primary btn-block btn-lg"
                            type="button">
                            Click here to Sign
                        </button>
                        <div>Use the above button to add/change your Signature</div>
                    </div>
                    {
                        signatureDataURL !== undefined && <div className="py-3" style={{ width: '100%' }}>
                            <button
                                onClick={this.onApproveClick}
                                className="btn btn-success btn-lg btn-block"
                                type="button">
                                Approve Signature
                            </button>
                            <div>Use the above button to approve this Signature</div>
                        </div>
                    }
                </div>

            </>
        )
    }

    renderModal = () => {
        const windowWidth = window.innerWidth;
        const modalCSS = windowWidth <= 768 ? "modal-fw" : "modal-lg";
        let multiplier = 2;
        if (windowWidth <= 768 && windowWidth > 425) {
            multiplier = 1.6
        } else if (windowWidth <= 425) {
            multiplier = 1
        }
        return (
            <React.Fragment>
                <ModalWindow
                    title="Signature"
                    backdrop="static"
                    className={modalCSS}
                    onCancel={this.onHideModal}
                >

                    <div className="row">
                        <div className="col-md-12 text-right">
                            <button type="button" onClick={this.onClearSign} className="btn btn-link p-0 text-danger">Clear Signature</button>
                        </div>
                        <div className="col-md-12 text-center">
                            <div className="" style={{ overflow: 'auto' }}>
                                <SignatureCanvas
                                    ref={(ref: any) => { this.sigPad = ref }}
                                    // penColor='green'
                                    canvasProps={{ width: 300 * multiplier, height: 70 * multiplier, className: 'border-dashed-gray' }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col mb-3">
                            <button type="button" onClick={this.onHideModal} className="btn btn-secondary px-5">Cancel</button>
                        </div>
                        <div className="col-auto">
                            <button type="button" onClick={this.OnSaveSign} className="btn btn-primary px-5">Save</button>
                        </div>
                    </div>
                </ModalWindow>
            </React.Fragment>
        )
    }

    renderApproveConfirmModal = () => {
        return (
            <React.Fragment>
                <ModalWindow
                    title="Confirm Approval"
                    backdrop="static"
                    className="modal-md"
                    onCancel={this.onHideApproveConfirm}
                >
                    <div className="mb-3">
                        Please confirm you are signing for the 2 documents before approving.
                    </div>
                    <div className="d-flex justify-content-end">
                        <button type="button" onClick={this.onHideApproveConfirm} className="btn btn-secondary mr-2">Cancel</button>
                        <button type="button" onClick={this.onConfirmApprove} className="btn btn-success">Approve</button>
                    </div>
                </ModalWindow>
            </React.Fragment>
        )
    }

    sigPad: any = {};

    onClearSign = () => {
        this.sigPad.clear()
    }

    OnSaveSign = () => {
        const signatureDataURL = this.sigPad.getTrimmedCanvas().toDataURL('image/png')
        const { linkDetail } = this.state;
        const documentDetail = JSON.parse(JSON.stringify(this.state.documentDetail));
        if (linkDetail.linkForBorrower) {
            documentDetail.borrowerSignature = signatureDataURL;
        } else {
            documentDetail.coBorrowerSignature = signatureDataURL;
        }


        this.setState({
            documentDetail,
            signatureDataURL
        })
        this.onHideModal();
    }

    onApproveClick = () => {
        const { documentDetail } = this.state;

        if (documentDetail && documentDetail.lenderId === constant.lenderId.powerExpress) {
            // For Power Express only, show a nicer confirmation modal
            this.setState({ showApproveConfirm: true });
        } else {
            // For all other lenders, approve directly
            this.onSaveSignature();
        }
    }

    onHideApproveConfirm = () => {
        this.setState({ showApproveConfirm: false });
    }

    onConfirmApprove = () => {
        this.setState({ showApproveConfirm: false }, () => {
            this.onSaveSignature();
        });
    }

    onSaveSignature = () => {
        const { uid, signatureDataURL, linkDetail, documentDetail } = this.state;

        const model = {
            uid, loanDetailId: documentDetail.loanDetailId,
            signatureDataURL,
            heterIskaId: documentDetail.id,
            dated: linkDetail.todaysDate,
            linkForBorrower: linkDetail.linkForBorrower,
            linkForCoBorrower: linkDetail.linkForCoBorrower
        }

        uploadSignature(model).then(async (res: any) => {
            if (res.error) {
                this.props.context.toast.error(res.error)
            } else {
                this.props.context.toast.success('The Signature has been successfully Uploaded');
                await sleep(3);
                window.location.reload();
            }
        })
    }
}

export default WithToastContext(HeterIskaSignature);